import React, { createContext, useState, useContext, useEffect } from 'react';

// Create Environment Context
const EnvironmentContext = createContext();

// Custom hook to use the environment context
export function useEnvironment() {
  return useContext(EnvironmentContext);
}

// Provider component
export function EnvironmentProvider({ children }) {
  const [environments] = useState([
    { id: 'production', name: 'Production' }
  ]);
  const [activeEnvironment, setActiveEnvironment] = useState('production');
  const [loading, setLoading] = useState(true);

  // Initialize active environment from local storage or set to default
  useEffect(() => {
    // Always use production
    setActiveEnvironment('production');
    localStorage.setItem('activeEnvironment', 'production');
    setLoading(false);
  }, []);

  // Switch environment - simplified to no-op since we only have production
  const switchEnvironment = (environmentId) => {
    if (environmentId === 'production') {
      return true;
    }
    return false;
  };

  // Get environment name
  const getEnvironmentName = (environmentId) => {
    const env = environments.find(e => e.id === environmentId);
    return env ? env.name : environmentId;
  };

  // Value object with environment functionality
  const value = {
    environments,
    activeEnvironment,
    switchEnvironment,
    getEnvironmentName,
    loading
  };

  return (
    <EnvironmentContext.Provider value={value}>
      {!loading && children}
    </EnvironmentContext.Provider>
  );
}

export function getEnvironments() {
  return [
    { id: 'production', name: 'Production' }
  ];
}